import * as mutationTypes from './mutation-types';
import * as actionTypes from './action-types';

/**
 * Unnamespace the type keys for `scope`. simplifies using namespaced modules
 *
 * @export
 * @param {Object} originalTypes object containing the original types
 * @param {String|RegExp} scope
 * @returns
 */
export function getTypesForScope(originalTypes, scope) {
  const out = {};
  let pattern = scope;
  if (!(scope instanceof RegExp)) {
    pattern = new RegExp(`^${scope}/`);
  }
  Object.keys(originalTypes)
    .forEach((type) => {
      out[type] = originalTypes[type].replace(pattern, '');
    });

  return out;
}

/**
 * Get the mutation types for the scope
 *
 * @export
 * @param {String|RegExp} scope
 * @param {Object} [types=mutationTypes] map of mutation type identifiers to the actual unique and namespaced mutation types
 * @returns {Object} map of mutation type identifiers to the actual types with the `scope`'s types unnamespaced
 */
export function getMutationsForScope(scope, types = mutationTypes) {
  return getTypesForScope.call(this, types, scope);
}

/**
 * Get the mutation types for the scope
 *
 * @export
 * @param {String|RegExp} scope
 * @param {Object} [types=mutationTypes] map of mutation type identifiers to the actual unique and namespaced mutation types
 * @returns {Object} map of mutation type identifiers to the actual types with the `scope`'s types unnamespaced
 */
export function getActionsForScope(scope, types = actionTypes) {
  return getTypesForScope.call(this, types, scope);
}
